export const RoundNumber = () => {
  const roundTo = (value, decimals = 2) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return null;

    const factor = Math.pow(10, decimals);
    return Math.round(num * factor) / factor;
  };

  return {
    roundTo,
  };
};